import React from 'react';
import gpticamLogo from '../assets/gpticam.png';
import capesLogo from '../assets/capes.png';
import inovaLogo from '../assets/inovaedu.png';
import ifapLogo from '../assets/ifap.png';
import liaredLogo from '../assets/liared.png';

interface Supporter {
  name: string;
  logo: string;
}

const supporters: Supporter[] = [
  { name: 'GPTICAM', logo: gpticamLogo },
  { name: 'IFAP – Campus Macapá', logo: ifapLogo },
  { name: 'CAPES', logo: capesLogo },
  { name: 'Inova Educação', logo: inovaLogo },
  { name: 'LIARED', logo: liaredLogo },
];

// Caixa de tamanho fixo pra todas as logos ocuparem o mesmo espaço no
// carrossel, mesmo com proporções originais diferentes entre si.
const SupporterItem = ({ supporter }: { supporter: Supporter }) => (
  <div className="h-8 w-24 md:h-9 md:w-28 flex items-center justify-center">
    <img
      src={supporter.logo}
      alt={supporter.name}
      title={supporter.name}
      className="max-h-full max-w-full object-contain grayscale opacity-70 transition-all duration-300 hover:grayscale-0 hover:opacity-100"
    />
  </div>
);

const SupportersSection = () => {
  return (
    <section className="relative pt-7 pb-5 md:pt-8 md:pb-6 bg-muted/50 overflow-hidden">
      <div className="relative container mx-auto px-4">
        <p className="text-center font-body text-xs text-muted-foreground uppercase tracking-wider mb-3">
          Desenvolvido em parceria com
        </p>

        <div className="relative mx-auto max-w-4xl overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
          <div className="supporters-track flex w-max items-center gap-x-14 md:gap-x-20 py-1">
            {[...supporters, ...supporters].map((supporter, index) => (
              <div key={`${supporter.name}-${index}`} className="flex-shrink-0">
                <SupporterItem supporter={supporter} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportersSection;
